import { LogoContainer } from "../styles/LogoContainer.style";
const Logo = () => {
 return (
  <LogoContainer>
   <h1>Go Crypto</h1>
  </LogoContainer>
 );
};

export default Logo;
